module.exports = __webpack_public_path__ + "static/media/4.c16e59d7.png";